//

    /*
    
	background: white;
	width: 21cm;
	height: 29.7cm;
	display: block;
	margin: 0 auto;
	margin-bottom: 0.5cm;
	box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);
    */
export const TsrPageStyle = {
    background: 'white',
    width: '21cm',
    height: '29.7cm',
    display: 'block',
    margin: '0 auto',
    marginBottom: '0.5cm',
    boxShadow: '0 0 0.5cm rgba(0,0,0,0.5)',
    fontFamily: 'SeoulNamsanMWeb',
};

export const TsrStyles = {
    div60x4: {width:"60mm",height:'4mm'},
    div65x4: {width:"65mm",height:'4mm'},
    divSign: {borderBottom: '1px solid', width: '31mm'}, // border-bottom: 1px solid; width:31mm
    noTopMargin: {marginTop: '0mm'},
    topMargin1mm: {marginTop: '1mm'},
    topMargin2mm: {marginTop: '2mm'},
    font12px: {fontSize: '12px'},
    font11px: {fontSize: '11px'},
    width25mm: {width: '25mm'},
    width40mm: {width: '40mm'},
    width60mm: {width: '60mm'},
    width65mm: {width: '65mm'},
    width80mm: {width: '80mm'},
};
// return yyyyMMdd HHmm (from yyyy-mm-dd HH:mm:ss)
export function tsrDateTime(dateTime) {
    if(dateTime) return dateTime.substring(0, 16); //.replace(/[-:]/g, '');
    return '';
}
export function tsrLetter(text, idx) {
    if(text && text.length > idx) return text[idx];
    return '';
}
export function tsrTemperature(temp) {
    if(temp === 'off') return 'off';
    if(temp !== null && temp !== undefined)
        return temp + ' ℃';
    return '';
}
export function tsrNumber(num) {
    return num >0 ? num : '';
}
export function tsrStoreIdPlusVehPlates(tsrData) {
    if(!tsrData.storeId) return '';
    // storeId : padd zeros to make 4 digits
    const storeId4 = tsrData.storeId.padStart(4, '0');
    // get last 4 digits of vehPlates
    const vehPlates4 = tsrData.vehPlates.slice(-4);
    return `${storeId4}${vehPlates4}`;
}
/*

type TransPlanTsr {
	planId: String
	dcCd: String
	arriveId: String
	storeId: String
	comId: String
	dcStaffName: String
	agentStaffName: String
	cargoStaffName: String
	cargoTel: String
	planDate: String
	planTime: String
	hocha: Int
	transTypeCd: String
	txStage: String
	vehTypeId: String
	vehTypeName: String
	cargoUnit: String
	loadCapa: Float
	loadCapaText: String
	shprReqTime: String
	dptrReqTime: String
	arrReqTime: String
	dockno: String
	charge: Int
	addCharge: Int
	note: String
	reqStateFlag: String
	transFlag: Boolean
	vehPlates: String
	driverName: String
	driverMobile: String
	bol1: String
	bol2: String
	bol3: String
	loadCount: Int
	loadStTime: String
	loadEnTime: String
	prosDptrTime: String
	prosArrTime: String
	sealNo1: String
	sealNo2: String
	sealNo3: String
	loadStaffName: String
	unsoldBol: String
	unsoldPallet: Int
	unsoldCount: Int
	memo: String
	inputArrTime: String
	traceStatus: Boolean
	regTypeCd: String
	endFlag: String
	zipgiBool: Boolean
	inputDptrTime: String
	printDate: String
	printUser: String
	inputTempF: String
	inputTempM: String
	inputTempR: String
	aPalKpp: Int
	aPalAju: Int
	aRollN: Int
	aRollJum: Int
	aB2bKpp: Int
	aB2bAju: Int
	aEtc: Int
	aTray: Int
	tempF: String
	tempM: String
	tempR: String
	fFPalKpp: Int
	fMPalKpp: Int
	fRPalKpp: Int
	fFPalAju: Int
	fMPalAju: Int
	fRPalAju: Int
	fFShrFull: Int
	fMShrFull: Int
	fRShrFull: Int
	fFShrHalf: Int
	fMShrHalf: Int
	fRShrHalf: Int
	fFEtcKpp: Int
	fMEtcKpp: Int
	fREtcKpp: Int
	fFEtcAju: Int
	fMEtcAju: Int
	fREtcAju: Int
	fNjc: Int
	fUcolor: Int
	fOctagon: Int
	fTray: Int
	eFDolly: Int
	eMDolly: Int
	eRDolly: Int
	eFDollycart: Int
	eMDollycart: Int
	eRDollycart: Int
	eFRoll: Int
	eMRoll: Int
	eRRoll: Int
	eFPalKpp: Int
	eMPalKpp: Int
	eRPalKpp: Int
	eFPalAju: Int
	eMPalAju: Int
	eRPalAju: Int
	eCigar: Int
	eCorn: Int
	ePulp: Int
	eMu: Int
	eJumDolly: Int
	eJumDollycart: Int
	eJumRoll: Int
	reserve3: Int
	aOpSpec: Int
	aOpJum: Int
	aOpTrunc: Int
	aHiDanpra: Int
	aHiRoll: Int
	regDate: String
	regUser: String
	dcName: String
	dcTypeCd: String
	dcTypeName: String
	dcTransStaffName: String
	dcOperStaffName: String
	dcOfficeStaffName: String
	dcOfficeTelno: String
	comName: String
	comAgentName: String
	comOfficeTel: String
    dcUseYn: String
	vehInfoSeq: Int
	vehId: Int
    gpsTime: String
	transPosYn: String
	rentYn: String
	storeName: String
	storeStaffName: String
	storeAddr: String
	storeOfficeTelno: String
	storeSecuTelno: String
	transType: String
	reqState: String
	regUserName: String
    bulkItems: [BulkItems]
    bindStores: [BindStores]
}

Data json:
{
    "planId": "202501140883",
    "dcCd": "981",
    "arriveId": "981015",
    "storeId": "015",
    "comId": "2012091002",
    "dcStaffName": "김현식            ",
    "agentStaffName": "이재철",
    "cargoStaffName": "이정훈",
    "cargoTel": "031-201-8130",
    "planDate": "2025-01-15",
    "planTime": "2025-01-15 20:09:14",
    "hocha": 3,
    "transTypeCd": "01",
    "txStage": "legacy",
    "vehTypeId": "71",
    "vehTypeName": "용차냉동5톤X",
    "cargoUnit": "pallet",
    "loadCapa": null,
    "loadCapaText": "14Pallet",
    "shprReqTime": "2025-01-15 02:00:00",
    "dptrReqTime": "2025-01-15 05:10:00",
    "arrReqTime": "2025-01-15 06:00:00",
    "dockno": "038",
    "charge": 108000,
    "addCharge": null,
    "note": null,
    "reqStateFlag": "2",
    "transFlag": true,
    "vehPlates": "경기89사3400",
    "driverName": "박순범(b3)",
    "driverMobile": "010-9894-3557",
    "bol1": "00119817021464444",
    "bol2": null,
    "bol3": null,
    "loadCount": 0,
    "loadStTime": "2025-01-15 03:50:00",
    "loadEnTime": "2025-01-15 03:50:00",
    "prosDptrTime": "2025-01-15 05:10:00",
    "prosArrTime": "2025-01-15 06:00:00",
    "sealNo1": "RW709",
    "sealNo2": "RW708",
    "sealNo3": "RW707",
    "loadStaffName": "박철",
    "unsoldBol": null,
    "unsoldPallet": 0,
    "unsoldCount": 0,
    "memo": null,
    "inputArrTime": "2025-01-15 05:40:00",
    "traceStatus": false,
    "regTypeCd": "M",
    "endFlag": null,
    "zipgiBool": false,
    "inputDptrTime": "2025-01-15 00:00:00",
    "printDate": "2025-01-15 04:00:36",
    "printUser": "PSH",
    "inputTempF": null,
    "inputTempM": null,
    "inputTempR": null,
    "aPalKpp": 0,
    "aPalAju": 0,
    "aRollN": 0,
    "aRollJum": 0,
    "aB2bKpp": 0,
    "aB2bAju": 0,
    "aEtc": 0,
    "aTray": 0,
    "tempF": "5",
    "tempM": "off",
    "tempR": "off",
    "fFPalKpp": 8,
    "fMPalKpp": 0,
    "fRPalKpp": 0,
    "fFPalAju": 4,
    "fMPalAju": 0,
    "fRPalAju": 0,
    "fFShrFull": 0,
    "fMShrFull": 0,
    "fRShrFull": 0,
    "fFShrHalf": 0,
    "fMShrHalf": 0,
    "fRShrHalf": 0,
    "fFEtcKpp": 0,
    "fMEtcKpp": 0,
    "fREtcKpp": 0,
    "fFEtcAju": 0,
    "fMEtcAju": 0,
    "fREtcAju": 0,
    "fNjc": 0,
    "fUcolor": 0,
    "fOctagon": 0,
    "fTray": 0,
    "eFDolly": 0,
    "eMDolly": 0,
    "eRDolly": 0,
    "eFDollycart": 0,
    "eMDollycart": 0,
    "eRDollycart": 0,
    "eFRoll": 0,
    "eMRoll": 0,
    "eRRoll": 0,
    "eFPalKpp": 0,
    "eMPalKpp": 0,
    "eRPalKpp": 0,
    "eFPalAju": 0,
    "eMPalAju": 0,
    "eRPalAju": 0,
    "eCigar": 0,
    "eCorn": 0,
    "ePulp": 0,
    "eMu": 0,
    "eJumDolly": 0,
    "eJumDollycart": 0,
    "eJumRoll": 0,
    "reserve3": 0,
    "aOpSpec": 0,
    "aOpJum": 0,
    "aOpTrunc": 0,
    "aHiDanpra": 0,
    "aHiRoll": 0,
    "regDate": "2025-01-15 04:00:32",
    "regUser": "PSH",
    "dcName": "안성FDC",
    "dcTypeCd": "F",
    "dcTypeName": "신선",
    "dcTransStaffName": "최수호",
    "dcOperStaffName": "안기용",
    "dcOfficeStaffName": "김현식",
    "dcOfficeTelno": "031-8056-8496",
    "dcUseYn": "Y",
    "comName": "동방-안성FDC",
    "comAgentName": "이재철",
    "comOfficeTel": "070-8630-7408",
    "vehInfoSeq": 29837,
    "vehId": null,
    "gpsTime": null,
    "transPosYn": null,
    "rentYn": "Y",
    "storeName": "영통점",
    "storeStaffName": "이정훈",
    "storeAddr": "경기도수원시영통구봉영로1576",
    "storeOfficeTelno": "031-201-8130",
    "storeSecuTelno": "031-201-8112",
    "transType": "WAVE1",
    "reqState": "TSR 발행",
    "regUserName": "박수황",
    "bulkItems": null,
    "bindStores": null,
    "__typename": "TransPlanTsr"
}
*/
/* 
export const TransPlanTsrSample = {
    planId: "202501140883",
    dcCd: "981",
    arriveId: "981015",
    storeId: "015",
    comId: "2012091002",
    dcStaffName: "김현식",
    agentStaffName: "이재철",
    cargoStaffName: "이정훈",
    cargoTel: "031-201-8130",
    planDate: "2025-01-15",
    planTime: "2025-01-15 20:09:14",
    hocha: 3,
    transTypeCd: "01",
    txStage: "legacy",
    vehTypeId: "71",
    vehTypeName: "용차냉동5톤X",
    cargoUnit: "pallet",
    loadCapa: null,
    loadCapaText: "14Pallet",
    shprReqTime: "2025-01-15 02:00:00",
    dptrReqTime: "2025-01-15 05:10:00",
    arrReqTime: "2025-01-15 06:00:00",
    dockno: "038",
    charge: 108000,
    addCharge: null,
    note: null,
    reqStateFlag: "2",
    transFlag: true,
    vehPlates: "경기89사3400",
    driverName: "박순범(b3)",
    driverMobile: "010-9894-3557",
    bol1: "00119817021464444",
    bol2: null,
    bol3: null,
    loadCount: 0,
    loadStTime: "2025-01-15 03:50:00",
    loadEnTime: "2025-01-15 03:50:00",
    prosDptrTime: "2025-01-15 05:10:00",
    prosArrTime: "2025-01-15 06:00:00",
    sealNo1: "RW709",
    sealNo2: "RW708",
    sealNo3: "RW707",
    loadStaffName: "박철",
    unsoldBol: null,
    unsoldPallet: 0,
    unsoldCount: 0,
    memo: null,
    inputArrTime: "2025-01-15 05:40:00",
    traceStatus: false,
    regTypeCd: "M",
    endFlag: null,
    zipgiBool: false,
    inputDptrTime: "2025-01-15 00:00:00",
    printDate: "2025-01-15 04:00:36",
    printUser: "PSH",
    inputTempF: null,
    inputTempM: null,
    inputTempR: null,
    aPalKpp: 0,
    aPalAju: 0,
    aRollN: 0,
    aRollJum: 0,
    aB2bKpp: 0,
    aB2bAju: 0,
    aEtc: 0,
    aTray: 0,
    tempF: "5",
    tempM: "off",
    tempR: "off",
    fFPalKpp: 8,
    fMPalKpp: 0,
    fRPalKpp: 0,
    fFPalAju: 4,
    fMPalAju: 0,
    fRPalAju: 0,
    fFShrFull: 0,
    fMShrFull: 0,
    fRShrFull: 0,
    fFShrHalf: 0,
    fMShrHalf: 0,
    fRShrHalf: 0,
    fFEtcKpp: 0,
    fMEtcKpp: 0,
    fREtcKpp: 0,
    fFEtcAju: 0,
    fMEtcAju: 0,
    fREtcAju: 0,
    fNjc: 0,
    fUcolor: 0,
    fOctagon: 0,
    fTray: 0,
    eFDolly: 0,
    eMDolly: 0,
    eRDolly: 0,
    eFDollycart: 0,
    eMDollycart: 0,
    eRDollycart: 0,
    eFRoll: 0,
    eMRoll: 0,
    eRRoll: 0,
    eFPalKpp: 0,
    eMPalKpp: 0,
    eRPalKpp: 0,
    eFPalAju: 0,
    eMPalAju: 0,
    eRPalAju: 0,
    eCigar: 0,
    eCorn: 0,
    ePulp: 0,
    eMu: 0,
    eJumDolly: 0,
    eJumDollycart: 0,
    eJumRoll: 0,
    reserve3: 0,
    aOpSpec: 0,
    aOpJum: 0,
    aOpTrunc: 0,
    aHiDanpra: 0,
    aHiRoll: 0,
    regDate: "2025-01-15 04:00:32",
    regUser: "PSH",
    dcName: "안성FDC",
    dcTypeCd: "F",
    dcTypeName: "신선",
    dcTransStaffName: "최수호",
    dcOperStaffName: "안기용",
    dcOfficeStaffName: "김현식",
    dcOfficeTelno: "031-8056-8496",
    dcUseYn: "Y",
    comName: "동방-안성FDC",
    comAgentName: "이재철",
    comOfficeTel: "070-8630-7408",
    vehInfoSeq: 29837,
    vehId: null,
    gpsTime: null,
    transPosYn: null,
    rentYn: "Y",
    storeName: "영통점",
    storeStaffName: "이정훈",
    storeAddr: "경기도수원시영통구봉영로1576",
    storeOfficeTelno: "031-201-8130",
    storeSecuTelno: "031-201-8112",
    transType: "WAVE1",
    reqState: "TSR 발행",
    regUserName: "박수황",
    bulkItems: null,
    bindStores: null,
    __typename: "TransPlanTsr"
};
 */